import Vue from 'vue'
import Router from 'vue-router'
import Login from '../pages/login/login'
import Videos from '../pages/videos/videos'
import VideoAdd from '../pages/videos/videoAdd' 
import PopTopicCtm from '../pages/cafe/popTopicCtm'
import popBizReuters from '../pages/cafe/popBizReuters'
import VideoModify from '../pages/videos/videoModify'
import PopNewsLearn from '../pages/cafe/popNewsLearnRecommend'
import PopNewsLearnDaily from '../pages/cafe/popNewsLearnRecommendDaily'
import GuideNew from '../pages/cafe/guideNew'
import GuideSnew from '../pages/cafe/guideSnew'
import PopTranslate from '../pages/cafe/popTranslate'
import Reuters from '../pages/reuters/reuters'
import MailRecommend from '../pages/reuters/mailRecommend'
import Unknown from '../pages/erorr/404page.vue'
import MailChange from '../pages/reuters/mailChange'
import pick4u from '../pages/p4u/pick4u'
import pick4uDetail from '../pages/p4u/pick4uDetail'
import pick4uVideo from '../pages/p4u/pick4uVideo'
import bookList from '../pages/book/bookList';
import bookAdd from '../pages/book/bookAdd';


Vue.use(Router)

const routes = [
  {
    path: '*',
    name: 'Unknown',
    component: Unknown
  },
  {
    path: '/',
    name: 'Login',
    component: Login,
    beforeEnter: function (to, from, next) {
      localStorage.removeItem('reuterContentsParams')
      next()
    }
  },
  {
    path: '/login',
    name: 'Login2',
    component: Login,
    beforeEnter: function (to, from, next) {
      localStorage.removeItem('reuterContentsParams')
      next()
    }
  },
  {
    path: '/videos',
    name: 'Videos',
    component: Videos
  },
  {
    path: '/videos/add',
    name: 'VideoAdd',
    component: VideoAdd,
    beforeEnter: function (to, from, next) {
      localStorage.removeItem('reuterContentsParams')
      next()
    }
  },
  {
    path: '/videos/modify/:idx',
    name: 'VideoModify',
    component: VideoModify
  },
  {
    path: '/cafe/pop_topic_ctm',
    name: 'popTopicCtm',
    component: PopTopicCtm
  },
  {
    path: '/cafe/pop_biz_reuters',
    name: 'popBizReuters',
    component: popBizReuters
  },
  {
    path: '/cafe/pop_news_learn_recommend',
    name: 'popNewsLearnRecommend',
    component: PopNewsLearn
  },
  {
    path: '/cafe/pop_news_learn_recommend_daily',
    name: 'popNewsLearnRecommendDaily',
    component: PopNewsLearnDaily
  },
  {
    path: '/cafe/guide_new',
    name: 'GuideNew',
    component: GuideNew
  },
  {
    path: '/reuters',
    name: 'Reuters',
    component: Reuters
  },
  {
    path: '/cafe/guide_snew',
    name: 'GuideSnew',
    component: GuideSnew
  },
  {
    path: '/cafe/pop_translate',
    name: 'PopTranslate',
    component: PopTranslate
  },
  {
    path: '/mail_recommend',
    name: 'MailRecommend',
    component: MailRecommend
  },
  {
    path: '/cafe_email_change',
    name: 'MailChange',
    component: MailChange
  },
  {
    path: '/pick4u',
    name: 'Pick4u',
    component: pick4u,
    beforeEnter: function (to, from, next) {
      localStorage.removeItem('contentsParams')
      next()
    }
  },
  {
    path: '/pick4u/:id',
    name: 'Pick4uDetail',
    component: pick4uDetail
  },
  {
    path: '/pick4uVideo',
    name: 'Pick4uVideo',
    component: pick4uVideo
  },
  {
    path : '/booklist',
    name: 'BookList',
    component: bookList
  },
  {
    path: '/book/bookAdd',
    name: 'BookAdd',
    component: bookAdd
  },
  {
    path: '/book/bookDetail/:id/:version',
    name: 'BookDetail',
    component: (()=>import('../pages/book/bookDetail'))
  },
  {
    path: '/book/bookModify/:id/:version',
    name: 'BookModify',
    component: (()=>import('../pages/book/bookModify'))
  },
  {
    path: '/book/bookVersionAdd/:id/:version',
    name: 'BookVersionAdd',
    component: (()=>import('../pages/book/bookVersionAdd'))
  },
  {
    path: '/pdf/pdfinit/:pdf',
    name: 'pdfInit',
    component: (()=>import('../pages/pdf/pdfInit'))
  },
  {
    path: '/pdf/pdfinit2/:pdf',
    name: 'pdfInit2',
    component: (()=>import('../pages/pdf/pdfInit2'))
  },
  {
    path: '/pdf/pdfviewer',
    name: 'pdfViewer',
    component: (()=>import('../pages/pdf/pdfViewer'))
  },
  {
    path: '/pdf/pdfviewer2',
    name: 'pdfViewer2',
    component: (()=>import('../pages/pdf/pdfViewer2'))
  },
  {
    path:'/editor',
    name:'Editor',
    component: (()=>import('../pages/editor/editor'))
  },
  {
    path:'/editor/add',
    name:'EditorAdd',
    component: (()=>import('../pages/editor/editorAdd'))
  },
  {
    path:'/editor/modify',
    name:'EditorModify',
    component: (()=>import('../pages/editor/editorModify'))
  }  
  
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js